import { AgFns, GridOptionsExt } from "@/shared/ag-fns";
import { DomainBaseComponent } from "@/shared/domain-base.component";
import { DomainService } from "@/shared/domain.service";
import { GridReadyEvent } from "@ag-grid-community/core";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { takeUntil } from "rxjs";

@Component({
  selector: "app-scan-pull-batches",
  templateUrl: "./scan-pull-batches.component.html",
  standalone: false,
})
export class ScanPullBatchesComponent
  extends DomainBaseComponent
  implements OnInit
{
  gridOptions: GridOptionsExt;

  constructor(
    protected domainService: DomainService,
    protected route: ActivatedRoute
  ) {
    super(domainService);

    this.route.queryParamMap.pipe(takeUntil(this.onDestroy)).subscribe(() => {
      this.updateFromContext();
    });
  }

  async updateFromContext() {
    this.gridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onGridReady,
      onRowSelected: this.onRowSelected,
      rowModelType: "clientSide",
    });
    AgFns.captureGridRouteParams(this.gridOptions, this.route, "id");
  }

  onGridReady(event: GridReadyEvent) {
    const colDefs = [
      {
        ...AgFns.createButtonProps(
          "",
          this.showBatches.bind(this),
          { label: "Select Batch" }
        ),
        colId: "Select Batch",
        width: 140,
      },
      { headerName: "Batch #", field: "account.accountName" },
    ];
    AgFns.initGrid(event, colDefs);
    AgFns.applyGridRouteParams(this.gridOptions);
    AgFns.autoSizeAllColumns(this.gridOptions);
  }

  showBatches(e: any) {}

  onRowSelected() {}
}
